<div class="modal-header font-size-18 font-weight-700 artstuff-orange-fg">{{ 'ERROR_DIALOG.HEADER' | translate }}</div>
<div class="mat-dialog-content p-0 font-weight-400 mat-body-1">{{ 'ERROR_DIALOG.MESSAGE' | translate }}</div>
<div class="w-100-p text-center">
    <button mat-raised-button class="text-center artstuff-orange text-uppercase mat-subheading-2 text-bold" (click)="dialogRef.close(true)">
        {{ 'ERROR_DIALOG.BUTTON_TEXT' | translate }}
    </button>
</div>
